import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e8ddba3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e8ddba3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ddba3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8ddba3c')) {
      api.createRecord('e8ddba3c', component.options)
    } else {
      api.reload('e8ddba3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e8ddba3c&scoped=true", function () {
      api.rerender('e8ddba3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/theme/index.vue"
export default component.exports